function BeforeStay(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H10l-4 4V8c0-1.1.9-2 2-2zm3 10.143v-4.286h5.077V9L22 14l-5.923 5v-2.857H11z"
        fill="#000"
      />
    </svg>
  )
}

export default BeforeStay
